module.exports = __webpack_public_path__ + "media/application/images/2023/Headline SM-8638ad22f6fed9f0546d996730be7c4c.png";